import {
    getLegalMattersListByCategory,
    getLegalMattersListByFilter,
    getLegalMattersListById,
} from '../../configs/environments/firebase/firebaseApp';
  
export const GET_LEGALMATTERS_BY_CATEGORY = 'GET_LEGALMATTERS_BY_CATEGORY';
export const GET_LEGALMATTERS_BY_FILTER = 'GET_LEGALMATTERS_BY_FILTER';
export const GET_LEGALMATTERS_BY_ID = 'GET_LEGALMATTERS_BY_ID';

const gettingLegalMattersByCategory = (data) => {
    return {
        type: GET_LEGALMATTERS_BY_CATEGORY,
        data,
    };
};

const gettingLegalMattersByFilter = (data) => {
    return {
        type: GET_LEGALMATTERS_BY_FILTER,
        data,
    };
};

const gettingLegalMattersById = (data) => {
    return {
        type: GET_LEGALMATTERS_BY_ID,
        data,
    };
};

export const getLegalMattersByCategory = category => dispatch => {
    return new Promise(async (resolve, reject) => {
        try {
            const data = await getLegalMattersListByCategory(category)
            dispatch(gettingLegalMattersByCategory(data));
            return resolve('success');
        } catch (error) {
            console.log('error', error);
            return reject(error);
        }
    })
};

export const getLegalMattersByFilter = params => dispatch => {
    return new Promise(async (resolve, reject) => {
        try {
            const data = await getLegalMattersListByFilter(params)
            dispatch(gettingLegalMattersByFilter(data));
            return resolve('success');
        } catch (error) {
            console.log('error', error);
            return reject(error);
        }
    })
};

export const getLegalMattersById = params => dispatch => {
    return new Promise(async (resolve, reject) => {
        try {
            const data = await getLegalMattersListById(params)
            dispatch(gettingLegalMattersById(data));
            return resolve(data);
        } catch (error) {
            return reject(error);
        }
    })
};